<template>
	<el-container direction="vertical" class="layout h-100">
		<page-header v-if="!whiteList.includes(route.name as string)">
			<template #title>
				<div class="showHideSide" @click="isShowSide = !isShowSide">
					<el-icon v-if="!isShowSide">
						<DArrowRight />
					</el-icon>
					<el-icon v-else>
						<DArrowLeft />
					</el-icon>
				</div>
			</template>
		</page-header>
		<el-container class="over-hide">
			<el-aside v-if="!whiteList.includes(route.name as string) && isShowSide">
				<side :menu="menu"> </side>
			</el-aside>

			<el-main>
				<!-- <el-header>
					<el-tabs
						type="card"
						editable
						class="demo-tabs"
					>
						<el-tab-pane
							v-for="item in ['1','2','3','4']"
							:key="item"
							:label="item"
							:name="item"
						></el-tab-pane>
					</el-tabs>
				</el-header> -->
				<transition name="slide-fade">
					<router-view>
					</router-view>
				</transition>

			</el-main>
		</el-container>
	</el-container>
</template>

<script setup lang="ts">
import { defineProps, reactive, ref, watch, Ref, defineExpose, computed, toRefs } from 'vue';
import side from '@c/public/side/side.vue'
import pageHeader from '@c/public/pageHeader/pageHeader.vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { whiteList } from './util/class/common';
import { ArrowLeft, ArrowRight, Back, DArrowLeft, DArrowRight, Right } from '@element-plus/icons-vue';

const route = useRoute()
const store = useStore();
const menu = computed(() => store.state.menuList)
const state = reactive({
	isShowSide: true
})
const {
	isShowSide
} = toRefs(state)
</script>

<style lang="scss">
@import './static/style/variable.scss';

html,
body {
	height: 100%;
	margin: 0;
	padding: 0;
	font-family: '微软雅黑', '宋体';
	background-color: $dark-fill;
	color: $primary-text;
}

#app {
	height: 100%;
	font-size: $text-medium;
	color: $primary-text;

	.showHideSide {
			cursor: pointer;
			margin-left: 20px;
			.el-icon {
				font-size: 24px;
				line-height: 24px;
				color: #2b9466;
			}
		}
	
		.el-aside {
			width: 240px;
			
		}
		
	.el-main {
		padding: 0;
	}
}
</style>
